export default function HighLowPrimitive(overlay, ctx, layout, bar) {
    
    const [timestamp, open, high, low, close, volume] = bar.raw
    
    // Calculate positions
    const x = layout.t2screen(timestamp)
    const y_high = layout.$2screen(high)
    const y_low = layout.$2screen(low)
    
    // Draw vertical line from high to low
    ctx.strokeStyle = overlay.lineColor
    ctx.lineWidth = overlay.lineWidth
    ctx.lineCap = 'round'
    
    ctx.beginPath()
    ctx.moveTo(x, y_high)
    ctx.lineTo(x, y_low)
    ctx.stroke()
    
    // Draw small horizontal lines at high and low points
    const lineLength = layout.candlew * 0.3
    
    // High line
    ctx.beginPath()
    ctx.moveTo(x - lineLength / 2, y_high)
    ctx.lineTo(x + lineLength / 2, y_high)
    ctx.stroke()
    
    // Low line
    ctx.beginPath()
    ctx.moveTo(x - lineLength / 2, y_low)
    ctx.lineTo(x + lineLength / 2, y_low)
    ctx.stroke()
}
